export enum KanbanCorEnum {
  Cinza = 1,
  Azul = 2,
  Verde = 3,
  Amarelo = 4,
  Vermelho = 5,
  Roxo = 6,
  Laranja = 7,
  Ciano = 8,
}
